import React, { createContext, useContext } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const PenalExecutionContext = createContext();

export const usePenalExecution = () => useContext(PenalExecutionContext);

const getApiErrorMessage = (error) => {
  if (error?.response?.data?.detail) {
    return error.response.data.detail;
  }
  if (error?.response?.data?.non_field_errors?.[0]) {
    return error.response.data.non_field_errors[0];
  }
  return error?.message || 'Erro desconhecido';
};

export const PenalExecutionProvider = ({ children }) => {
  // Listar execuções penais
  const listPenalExecutions = async (params) => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        return;
      }

      const response = await api.get('internals/penalexecution/', {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar execuções penais', error);
      const apiMessage = getApiErrorMessage(error);
      toast.error(apiMessage || 'Erro ao buscar execuções penais');
    }
  };

  // Buscar uma execução penal por ID
  const getPenalExecutionById = async (id) => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        return;
      }

      const response = await api.get(`internals/penalexecution/${id}/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar execução penal', error);
      const apiMessage = getApiErrorMessage(error);
      toast.error(apiMessage || 'Erro ao buscar execução penal');
    }
  };

  // Criar execução penal
  const addPenalExecution = async (data) => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        return;
      }

      const response = await api.post('internals/penalexecution/', data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      toast.success('Execução penal criada com sucesso');
      return response.data;
    } catch (error) {
      console.error('Erro ao criar execução penal', error);
      const apiMessage = getApiErrorMessage(error);
      toast.error(apiMessage || 'Erro ao criar execução penal');
    }
  };

  // Atualizar execução penal
  const updatePenalExecution = async (id, data) => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        return;
      }

      const response = await api.patch(`internals/penalexecution/${id}/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      toast.success('Execução penal atualizada com sucesso');
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar execução penal', error);
      const apiMessage = getApiErrorMessage(error);
      toast.error(apiMessage || 'Erro ao atualizar execução penal');
    }
  };

  const value = {
    listPenalExecutions,
    getPenalExecutionById,
    addPenalExecution,
    updatePenalExecution,
  };

  return (
    <PenalExecutionContext.Provider value={value}>
      {children}
    </PenalExecutionContext.Provider>
  );
};
